export default function useLocale() {
  const getLocale = (lang) => {
    // please forgive me for this lazy pile of dung
    if (lang === 'en') {
      return 'en_GB';
    }

    return lang + '_' + lang.toUpperCase();
  };

  return {
    getLocale,
  };
}
